export class GameResult {
  constructor(
    public id: number,
    public gameType: string,
    public subType: string,
    public result: number,
    public resultCodeId: number,
    public moodLevel: number,
    public taskId: number,
    public completed: boolean,
    public trial: boolean,
    public resultDetails: string,
    public deviceType: string,
    public img1?: string,
    public img2?: string,
    public img3?: string
    ) {
  }
}
export class Img2Post {
  constructor(
    public id: number,
    public patientId: string,
    public img1?: string,
    public img2?: string
    ) {
  }
}

export class SdmtResult {
  constructor(
    public age: number,
    public hasDegree: boolean,
    public allItems: number,
    public correctAnswers: number,
    public errors: number,
    public empty: number,
    public result: number,
    public threshold: number
  ) { }
}


export class MemoryGameResult {
  constructor(
    public cardPairs: number,
    public matchedPairs: number,
    public wrongPairs: number,
    public result: number
  ) { }
}

export class WordGuessResult {
  constructor(
    public wordLength: number,
    public wordWeight: number,
    public uniqueStringLength: number,
    public correctLetters: number,
    public wrongLetters: number,
    public elapsedTime: number,
    public timerMax: number
  ) { }
}

export class ShapeRecallResult {
  constructor(
    public timerMax: number,
    public itemCount: number,
    public additionalShapeCount: number,
    public correctHits: number,
    public wrongHits: number,
    public elapsedTime: number,
    public result: number
  ) { }
}
export class WordRecallResult {
  constructor(
    public patientId: string,

    //hány másodperc alatt kell leírni a megjegyzett szavakat
    public timerMax: number,
    //hány szót kell memorizálni
    public itemCount: number,
    public result: number,
    //összes heyles válasz
    public correctAnswers: number,
    //kitalálandó szavak
    public words: string[],
    public recallRounds: RecallRound[]
  ) { }
}
export class ColorRecognitionResult {
  constructor(
    //mennyi idő alatt teljesítette a feladatot
    public timerMax: number,
    //hány színt kell kitalálni
    public itemCount: number,
    public correctHits: number,
    public result: number,
    //kitalálandó szavak
    public guessColors: GuessColor[],
  ) { }
}
export class DrawingTestResult {
  constructor(
    public patientId: string,
    //rajzolandó időpont
    public timeToDraw: string,
    //Körvonal
    public result1: number,
    //Számok
    public result2: number,
    //Mutatók
    public result3: number,
    
    public result4: number,
    public result5: number,

    //A rajz X koordinátái
    public freehandX: Array<Array<number>>,
    //A rajz Y koordinátái
    public freehandY: Array<Array<number>>,
    //Az óra képként való tárolás neve
    public img1: string,
    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class LetterRecognitionResult {
  constructor(
    public patientId: string,
    public letters: Letter[],
    public correctHits: number,
    public wrongHits: number,

    public result1: number,

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class RepeatSentencesResult {
  constructor(
    public patientId: string,
    //Ezeket kellett megismételni
    public sentence1: string,
    public sentence2: string,
    public words: string[],

    //a hangfájlok 
    public audio_sentence1: string,
    public audio_sentence2: string,

    public result1: number,
    public result2: number,
    public result3: number,
    public result4: number,
    public result5: number,

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class WritingResult {
  constructor(
    public patientId: string,

    public sentence1: string,
    public sentence2: string,

    public result1: number,
    public result2: number,

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class FluenciaResult {
  constructor(
    public patientId: string,

    //a hangfájl 
    public audio_sentence1: string,

    public result1: number,

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}

export class DummyResult {
  constructor(
    public patientId: string,

    public result1: number,
    public result2: number,
    public result3: number,
    public result4: number,
    public result5: number,
    public result6: number,

    //9-HPT és T25WT eredmények tárolására
    public numbers1: number[],

    //KMT eredmények tárolására
    public letters: Letter[],

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class BvmtRResult {
  constructor(
    public patientId: string,

    public bvmts: Bvmt[],

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class BvrtResult {
  constructor(
    public patientId: string,

    //Alapbeállítások
    //words[0] - opc1 - adminisztráció
    //words[1] - opc2 - form
    //words[2] - megjegyzés
    public words: string[],
    //A rajz X koordinátái
    public freehandX: Array<Array<number>>,
    //A rajz Y koordinátái
    public freehandY: Array<Array<number>>,
    //Eredmények
    public numbers1: number[],

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class RepeatNumbersResult {
  constructor(
    public patientId: string,
    //a megismétlendő számok 
    public numbers1: number[],
    //a visszafelé megismétlendő számkok 
    public numbers2: number[],

    //a megismétlendő számok (válasz) 
    public answer1: AnswerNumber[],
    //a visszafelé megismétlendő számkok (válasz) 
    public answer2: AnswerNumber[],

    public result1: number,
    public result2: number,

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class DelayedRecallResult {
  constructor(
    public patientId: string,
    //a megismétlendő szavak 
    public words: string[],

    //a megjegyzett szavak (válasz) 
    public recallRounds: RecallRound[],

    public result1: number,
    public result2: number,

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class CountDownResult {
  constructor(
    public patientId: string,
    //a helyes visszaszámolás 
    public numbers1: number[],

    //a páciens válaszai 
    public answer1: AnswerNumber[],
    //az eredmény
    public result1: number,

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class TimeOrientationResult {
  constructor(
    public patientId: string,

    //a páciens válaszai
    // 0 - év, 1 - évszak, 2 - hónap, 3 - nap, 4 - nap neve 
    public answer1: AnswerNumber[],
    //az eredmény
    public result1: number,

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}

export class PictureRecognitionResult {
  constructor(
    public patientId: string,
    //Kitalálandó állatok képeinek száma (pl. ha 1 -> 1.jpg) 
    public numbers1: number[],
    //a páciens válaszai 
    public words: string[],
    //az eredmény
    public result1: number,
    public result2: number,
    public result3: number,
    public result4: number,

    //Kiértékelés?
    public evaluation: boolean
  ) { }
}
export class IcaResult {
  constructor(
    //public age: number,
    //public hasDegree: boolean,
    public allItems: number,
    public correctAnswers: number,
    public errors: number,
    public empty: number,
    public details: IcaDetail[]
  ) { }
}
export class IcaDetail {
  constructor(
    public animal: boolean,
    public start: Date,
    public end: Date,
    public answer_time: Date,
    public reaction_time: number,
    public answer: boolean
  ) { }
}

export class Letter {
  constructor(
    //Felolvasott betű
    public letter: string,
    //Koppintott?
    public hit: boolean,
    //helyesen eltalált?
    public correct: boolean
  ) { }
}
export class Bvmt {
  constructor(
    //A rajz X koordinátái
    public freehandX: Array<Array<number>>,
    //A rajz Y koordinátái
    public freehandY: Array<Array<number>>,
    public bvmtResults: BvmtResult[],
  ) { }
}
export class BvmtResult {
  constructor(
    public position: boolean,
    public shape: boolean
  ) { }
}

export class Picture {
  constructor(
    public index: number,
    //Kép neve
    public name: string,
    //Kép könyvtár (animal/non-animal)
    public folder: string,
    //Állat?
    public animal: boolean,
    //megválaszolt?
    public answered: boolean,
    //helyesen eltalált?
    public correct: boolean,
    //válasz reakció ideje msec-ben
    public reactionTime: number,
    //sorrend
    public key: number
  ) { }
}
export class AnswerNumber {
  constructor(
    public answer: number,
    //helyesen eltalált?
    public correct: boolean
  ) { }
}
export class GuessColor {
  constructor(
    //Milyen színt írunk ki szövegesen
    public color: string,
    //Milyen a kiírt szöveg színe
    public foreColor: string,
    //egyeznek a színek?
    public correct: boolean,
    //Válasz
    public answer: boolean,
    //Időtúllépés
    public timeOut: boolean
  ) { }
}
export class RecallRound {
  constructor(
    //hány mp. alatt írta le a válaszokat
    public elapsedTime: number,
    //helyesen eltalált szavak száma
    public correctHits: number,
    //az adott forduló eredménye
    public roundResult: number,
    //leírt szavak
    public guessWords: GuessWord[],
  ) { }
}
export class GuessWord {
  constructor(
    public guessWord: string,
    //helyesírási hibák javítás eredménye
    public correctedWord: string,
    //helyesen eltalált?
    public correct: boolean,
    public answer?: boolean
  ) { }
}

export class RecallHeatMapResult {
  constructor(
    public word: string,
    public correct: boolean,
    public correctHits: number,
    public wordToGuess: boolean
    ) { }
}

export class GameResultDetails {
  constructor(
    public id: number,
    public gameType: string,
    public subType: string,
    public resultCodeId: number,
    public resultNumeric: number,
    public allItems: number,
    public correctAnswers: number,
    public errors: number,
    public empty: number,
    public words: string[],

    public cardPairs: number,
    public matchedPairs: number,
    public wrongPairs: number,

    public uniqueStringLength: number,
    public correctLetters: number,
    public wrongLetters: number,

    public itemCount: number,
    public additionalShapeCount: number,
    public correctHits: number,
    public wrongHits: number,

    public recallRounds: RecallRound[],
    public guessColors: GuessColor[],

    public patientId: string,
    //rajzolandó időpont
    public timeToDraw: string,
    //Körvonal
    public result1: number,
    //Számok
    public result2: number,
    //Mutatók
    public result3: number,
    public result4: number,
    public result5: number,
    public result6: number,
    public result7: number,
    public result8: number,

    //A rajz X koordinátái
    public freehandX: Array<Array<number>>,
    //A rajz Y koordinátái
    public freehandY: Array<Array<number>>,

    //Betű felismerő eredményei
    public letters: Letter[],

    //Mondat ismétlő

    //Első mondat
    public sentence1: string,
    //Második mondat
    public sentence2: string,

    //a hangfájlok
    public audio_sentence1: string,
    public audio_sentence2: string,

    //a megismétlendő számok 
    public numbers1: number[],
    //a visszafelé megismétlendő számkok 
    public numbers2: number[],

    //BVMT-R

    public bvmts: Bvmt[],

    //Kiértékelés?
    public evaluation: boolean

  ) { }
}
export class Player {
  constructor(
    public name: string,
    public level: number,
    public shift: number,
    public playTime: number,
    public rank: number
  ) { }
}
export class BadgesViewModel {
  constructor(
    public patientId: string,
    public level1: boolean,
    public date1: Date,
    public level2: boolean,
    public date2: Date,
    public level3: boolean,
    public date3: Date,
    public level4: boolean,
    public date4: Date
  ) { }
}
export class EvaluationCallBackResult {
  constructor(
    public direction: string,
    public result: number
  ) { }
}


